module.exports = __webpack_public_path__ + "img/sv74.29444efc.svg";